export default __webpack_public_path__ + "static/media/mushroom.34e5fe35.svg";